import { gql } from '@apollo/client';

export const ADD_PLAN = gql`
    mutation addPlan($idUser: ID!, $planInput: PlanInput!, $ptId: ID!){
        addPlan(idUser: $idUser, planInput: $planInput, ptId: $ptId) {
            _id
        }
    }
`;
